import React from 'react'
function UToggleSwitch(props) {
    return (
        <div className="u_toggle-switch">
            <input type="checkbox" id={props.id} {...props} readOnly onChange={props.onChange}
                   checked={props.checked}
                   name={props.name}/>
            <label htmlFor={props.id}/>
        </div>
    )
}

UToggleSwitch.propTypes = {}

export default UToggleSwitch
